<template>
  <div class="app-container">
    <el-tabs v-model="activeName" ref="tabs" type="border-card" v-tab-change:activeName="setActiveName">
      <el-tab-pane label="举报记录" name="appReportList">
        <app-report-list></app-report-list>
      </el-tab-pane>
      <el-tab-pane label="举报原因管理" name="appReportCategoryList">
        <app-report-category-list></app-report-category-list>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import appReportList from "@/views/systemManagement/AppReport/AppReportList";
import appReportCategoryList from "@/views/systemManagement/AppReport/AppReportCategoryList";

export default {
  name: "index",
  components: {
    appReportList,
    appReportCategoryList
  },
  data(){
    return {
      activeName:"appReportList"
    }
  }
}
</script>

<style scoped>

</style>